// import * as $ from 'jquery';
let echo = require('../bb-app/vendor/echo');

class LazyLoad {
    protected interval: any;

    public run(): void {
        // console.log('run lazy load');
        echo.init({
            offset: 500,
            throttle: 0,
            unload: false,
            // callback: function (element, op) {
            //     // $(element).hide();
            //     // $(element).fadeIn();
            //     // console.log(element, 'has been', op + 'ed');
            // }
        });
        this.loop();
    }

    protected loop(): void {
        this.interval = setInterval(() => {
            this.check();
        }, 500);
    }

    protected check(): void {
        // console.log('check');
        echo.render();
    }
}

export {LazyLoad};
